// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { TextStyle } from 'react-native';

import appColors, { alpha } from './colors';
import { contrastRatio } from './contrast';
import type { Skin } from './skin';

/** True where white reads better than black on the skin's panels: light ink on a dark ground. */
export function hasDarkPanels(colors: Skin['colors']): boolean {
  const panel = colors.background.panel;
  return contrastRatio(panel, '#FFFFFF') > contrastRatio(panel, '#000000');
}

const darkPanels = hasDarkPanels(appColors);

/**
 * A black drop shadow for text on a panel, or nothing on a light skin, where it only smudges
 * dark ink into the paper. Spread it into a text style: `...panelTextShadow(0.55, 2, 3)`.
 *
 * Text over photos, video, the map or painted artwork keeps a plain textShadowColor: that
 * ground is dark in every skin.
 */
export function panelTextShadow(opacity: number, offsetY: number, radius: number): TextStyle {
  if (!darkPanels) return {};
  return {
    textShadowColor: alpha(appColors.neutral.black, opacity),
    textShadowOffset: { width: 0, height: offsetY },
    textShadowRadius: radius,
  };
}
